import { ComponentProps } from 'react';
import { Tiles } from 'braid-design-system';

type TilesProps = ComponentProps<typeof Tiles>;

export enum LayoutSize {
  XSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge',
}

export interface LayoutParams {
  columns: TilesProps['columns'];
  maxCandidates: number;
}

export type LayoutDefinitions = Record<
  LayoutSize,
  | Array<(width: number, height: number) => LayoutParams | boolean>
  | LayoutParams
>;
